/*
 * File: UISwitchAll.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Display a toggle switch for checking/unchecking all child checkboxes
 */
import React from "react";
import { ListItem, ListItemText } from "@material-ui/core";
import { observer, PropTypes as mobxProbTypes } from "mobx-react";
import Switch from "@material-ui/core/Switch";
import PropTypes from "prop-types";

const UISwitchAll = ({ field }) => {
  const onCheck = async () => {
    let allChecked = isAllChecked();
    await field.options.forEach(option => {
      option.setSelected(!allChecked);
    });
    field.update();
  };

  const isAllChecked = () => {
    return field.isAllOptionsSelected();
  };

  return (
    <ListItem button onClick={onCheck} disableRipple divider>
      <ListItemText primary={"All " + field.label} />
      <Switch disableRipple checked={isAllChecked()} color="primary" />
    </ListItem>
  );
};

UISwitchAll.propTypes = {
  field: PropTypes.shape({
    isAllOptionsSelected: PropTypes.func.isRequired,
    options: PropTypes.oneOfType([
      PropTypes.array,
      mobxProbTypes.observableArray
    ]).isRequired,
    label: PropTypes.string,
    update: PropTypes.func.isRequired
  }).isRequired
};

export default observer(UISwitchAll);
